<div
    id="ReportToolbarComponent"
    [class.device-mobile]="isMobile()"
    [class.device-desktop]="!isMobile()"
    fxLayout="column"
    fxLayoutAlign="space-between none"
>
    <div
        class="report-toolbar-component_content"
        [class.m-24]="!isMobile()"
        [class.m-12]="pdf"
    >
        <div
            class="report-toolbar-component_title"
            fxLayout="row"
            fxLayoutAlign="start center"
        >
            @defer (when dateLabel) {
                <span
                    [class.text-14-bold]="!pdf"
                    [class.text-12-bold]="pdf"
                    [class.color-text-petroleum]="!options?.comparation?.active"
                    [class.active-comparation]="
                        isMobile() && options?.comparation?.active
                    "
                    [innerHTML]="dateLabel()"
                ></span>
                @if (options?.comparation?.active && isMobile()) {
                    <dsn-button-rounded
                        [type]="'secondary-cyan'"
                        [radius]="'full'"
                        [disabled]="loading"
                        [icon]="'fa-solid fa-xmark'"
                        [disabled]="false"
                        [typeButton]="'button'"
                        [size]="'medium'"
                        [labelPosition]="'bottom'"
                        [active]="false"
                        [labelFontSize]="'medium'"
                        (onClick)="onResetComparation()"
                    ></dsn-button-rounded>
                }
            } @placeholder {
                <dsn-skeleton-loader
                    [type]="'rectangle'"
                    [width]="'156px'"
                    [height]="'20px'"
                ></dsn-skeleton-loader>
            }
        </div>
        <div
            class="report-toolbar-component_desktop report-toolbar-component_navbar"
            [class.gap-16]="!pdf"
            [class.gap-8]="pdf"
            fxLayout="row"
            fxLayoutAlign="none center"
        >
            @if (dropdowns?.period) {
                <ngx-popover
                    #popoverPeriod
                    placement="bottom-start"
                    [disabled]="pdf"
                >
                    <div style="position: relative">
                        @if (pdf) {
                            <i
                                class="fa-solid fas fa-lock"
                                style="
                                    font-size: var(--font-size-12);
                                    color: var(--color-button-icon-hint);
                                    position: absolute;
                                    right: 4px;
                                    top: -6px;
                                    z-index: 10;
                                "
                            ></i>
                        }

                        <dsn-button
                            [prelabel]="
                                options?.comparation?.active ? 'Período:' : ''
                            "
                            [label]="periodLabel()"
                            [type]="'tertiary'"
                            [size]="this.pdf ? 'x-small' : 'medium'"
                            [fontWeight]="'regular'"
                            [disabled]="loading"
                            [iconLeft]="'fa-solid fa-calendar-days'"
                            [iconRight]="!this.pdf && 'fa-solid fa-caret-down'"
                            [active]="options?.comparation?.active"
                            [shadow]="!pdf"
                        ></dsn-button>
                    </div>

                    <ng-template ngx-popover-template>
                        <div
                            class="dsn-popover size-medium gap-16"
                            fxLayout="column"
                        >
                            <div
                                fxLayout="row"
                                fxLayoutAlign="space-between center"
                            >
                                <h1
                                    class="text-14-semi-bold color-text-primary"
                                >
                                    Período
                                </h1>
                            </div>

                            <app-available-dates-selector
                                [typeSelect]="'period'"
                                [scenarios]="scenarios"
                                [scenario]="options.scenario"
                                [startDate]="options.startDate"
                                [endDate]="options.endDate"
                                [availableDates]="periodAvailable()"
                                [periodName]="options.period"
                                [disabledStartDate]="
                                    options?.comparation?.active
                                "
                                [configs]="dropdownConfigs?.period"
                                [disabledScenario]="
                                    !!options?.budget || !!options?.projection
                                "
                                (handleApply)="onApplyPeriod($event)"
                                (handleSelectScenario)="
                                    onSelectScenarioPeriod($event)
                                "
                            >
                            </app-available-dates-selector>
                        </div>
                    </ng-template>
                </ngx-popover>
            }
            @if (dropdowns?.comparation) {
                <ngx-popover
                    [disabled]="pdf"
                    [placement]="
                        dropdowns?.projection ||
                        dropdowns?.budget ||
                        dropdowns?.goals
                            ? 'bottom-start'
                            : 'bottom-start'
                    "
                    #popoverComparation
                >
                    <div style="position: relative">
                        @if (pdf) {
                            <i
                                class="fa-solid fas fa-lock"
                                style="
                                    font-size: var(--font-size-12);
                                    color: var(--color-button-icon-hint);
                                    position: absolute;
                                    right: 4px;
                                    top: -6px;
                                    z-index: 10;
                                "
                            ></i>
                        }
                        <dsn-button
                            [prelabel]="
                                options?.comparation?.active
                                    ? 'Comparação:'
                                    : ''
                            "
                            [label]="comparationLabel()"
                            [type]="'tertiary'"
                            [size]="this.pdf ? 'x-small' : 'medium'"
                            [fontWeight]="'regular'"
                            [disabled]="loading"
                            [iconLeft]="'fa-solid fa-code-compare'"
                            [iconRight]="!this.pdf && 'fa-solid fa-caret-down'"
                            [active]="options?.comparation?.active"
                            [shadow]="!pdf"
                        ></dsn-button>
                    </div>

                    <ng-template ngx-popover-template>
                        <div
                            class="dsn-popover size-medium gap-16 popover-comparation dsn-scrollbar scroll-secondary"
                            fxLayout="column"
                        >
                            <div
                                fxLayout="row"
                                fxLayoutAlign="space-between center"
                            >
                                <h1
                                    class="text-14-semi-bold color-text-primary"
                                >
                                    Comparar com
                                </h1>
                            </div>
                            <app-available-dates-selector
                                [scenarios]="scenarios"
                                [scenario]="options?.comparation?.scenario"
                                [typeSelect]="'comparation'"
                                [startDate]="options.endDate"
                                [endDate]="options?.comparation?.date"
                                [allMonthsCompare]="
                                    options?.comparation?.allMonths
                                "
                                [availableDates]="comparationAvailable()"
                                [periodName]="options.period"
                                [configs]="dropdownConfigs?.comparation"
                                (handleApply)="
                                    onApplyComparation($event);
                                    popoverComparation.close()
                                "
                                (handleSelectScenario)="
                                    onSelectScenarioComparation($event)
                                "
                                (handleResetPeriod)="
                                    onResetComparation();
                                    popoverComparation.close()
                                "
                            >
                                @if (
                                    ["dre", "dreComparation"].includes(
                                        report?.type
                                    ) || report?.hasBalance
                                ) {
                                    <app-form-dre-balance-options
                                        desktop-content
                                        [(form)]="formDreBalanceOptions"
                                        [options]="report.options"
                                        [config]="{
                                            hideReference: [
                                                'balance',
                                                'balanceComparation'
                                            ].includes(report?.type)
                                        }"
                                    ></app-form-dre-balance-options>
                                }
                            </app-available-dates-selector>
                        </div>
                    </ng-template>
                </ngx-popover>
            }
            @if (dropdowns?.projection) {
                <ngx-popover #popoverProjection [disabled]="pdf">
                    <div style="position: relative">
                        @if (!loading && !company?.analysisPlusStatus && !pdf) {
                            <app-badge-rocket></app-badge-rocket>
                        }
                        <div style="position: relative">
                            @if (pdf) {
                                <i
                                    class="fa-solid fas fa-lock"
                                    style="
                                        font-size: var(--font-size-12);
                                        color: var(--color-button-icon-hint);
                                        position: absolute;
                                        right: 4px;
                                        top: -6px;
                                        z-index: 10;
                                    "
                                ></i>
                            }
                            <dsn-button
                                [label]="'Projeção'"
                                [type]="'tertiary'"
                                [fontWeight]="'regular'"
                                [size]="this.pdf ? 'x-small' : 'medium'"
                                [disabled]="loading"
                                [iconLeft]="'fa-solid fa-chart-line'"
                                [iconRight]="
                                    !this.pdf && 'fa-solid fa-caret-down'
                                "
                                [active]="!!options?.projection"
                                [shadow]="!pdf"
                            ></dsn-button>
                        </div>
                    </div>
                    <ng-template ngx-popover-template>
                        <div
                            class="dsn-popover size-minimum gap-16 report-toolbar-component_popover"
                            fxLayout="column"
                        >
                            <div
                                fxLayout="row"
                                fxLayoutAlign="space-between center"
                            >
                                <h1
                                    class="text-14-semi-bold color-text-primary"
                                >
                                    Projeção
                                </h1>
                            </div>
                            <div fxLayout="column" class="gap-8">
                                <div
                                    fxLayout="column"
                                    fxLayoutAlign="center center"
                                >
                                    <img
                                        class="report-toolbar-component_popover-image"
                                        [src]="
                                            company.analysisPlusStatus
                                                ? '/images/projection.png'
                                                : '/images/projection-y.png'
                                        "
                                        alt=""
                                    />
                                </div>

                                <p
                                    class="color-text-hint text-12-regular"
                                    fxLayout="column"
                                    fxLayoutAlign="center center"
                                >
                                    Simule os próximos resultados da empresa
                                    através do modelo de regressão linear.
                                </p>

                                @if (company?.analysisPlusStatus) {
                                    <div
                                        fxLayout="column"
                                        fxLayoutAlign="space-between center"
                                        class="gap-16"
                                    >
                                        <dsn-select
                                            class="full-width"
                                            [size]="'small'"
                                            [value]="formProjection._id"
                                            [placeholder]="
                                                'Selecione a projeção'
                                            "
                                            (handleValueChange)="
                                                onSelectProjection($event)
                                            "
                                        >
                                            @for (
                                                projection of projections;
                                                track $index
                                            ) {
                                                <dsn-option
                                                    [value]="
                                                        projection.props._id
                                                    "
                                                    >{{
                                                        projection.props.name
                                                    }}</dsn-option
                                                >
                                            }
                                        </dsn-select>
                                    </div>
                                }
                            </div>

                            @if (!loading && company?.analysisPlusStatus) {
                                <div
                                    fxLayout="row"
                                    fxLayoutAlign="end center"
                                    class="gap-16"
                                >
                                    <dsn-button
                                        [label]="'Limpar'"
                                        [type]="'secondary'"
                                        [size]="'medium'"
                                        [disabled]="
                                            loading || !options?.projection
                                        "
                                        [iconLeft]="'fa-solid fa-trash-can'"
                                        [active]="false"
                                        [fontWeight]="'bold'"
                                        (onClick)="
                                            onResetProjection();
                                            popoverProjection.close()
                                        "
                                    ></dsn-button>
                                    <dsn-button
                                        [label]="'Aplicar'"
                                        [type]="'primary'"
                                        [size]="'medium'"
                                        [disabled]="
                                            loading || !formProjection._id
                                        "
                                        [active]="false"
                                        [fontWeight]="'bold'"
                                        (onClick)="
                                            onApplyProjection();
                                            popoverProjection.close()
                                        "
                                    ></dsn-button>
                                </div>
                            } @else {
                                <dsn-button
                                    label="Solicitar Análise Plus"
                                    type="accent"
                                    [size]="'medium'"
                                    [width]="'full'"
                                    (onClick)="
                                        onRequestAnalysisPlus();
                                        popoverProjection.close()
                                    "
                                ></dsn-button>
                            }
                        </div>
                    </ng-template>
                </ngx-popover>
            }
            @if (dropdowns?.budget) {
                <ngx-popover #popoverBudget [disabled]="pdf">
                    <div style="position: relative">
                        @if (!loading && !company?.analysisPlusStatus && !pdf) {
                            <app-badge-rocket></app-badge-rocket>
                        }
                        <div style="position: relative">
                            @if (pdf) {
                                <i
                                    class="fa-solid fas fa-lock"
                                    style="
                                        font-size: var(--font-size-12);
                                        color: var(--color-button-icon-hint);
                                        position: absolute;
                                        right: 4px;
                                        top: -6px;
                                        z-index: 10;
                                    "
                                ></i>
                            }
                            <dsn-button
                                [prelabel]="''"
                                [label]="'Orçamento'"
                                [type]="'tertiary'"
                                [fontWeight]="'regular'"
                                [size]="this.pdf ? 'x-small' : 'medium'"
                                [disabled]="loading"
                                [iconLeft]="'fa-solid fa-coins'"
                                [iconRight]="
                                    !this.pdf && 'fa-solid fa-caret-down'
                                "
                                [active]="!!options?.budget"
                                [shadow]="!pdf"
                            ></dsn-button>
                        </div>
                    </div>
                    <ng-template ngx-popover-template>
                        <div
                            class="dsn-popover size-minimum gap-16 report-toolbar-component_popover"
                            fxLayout="column"
                        >
                            <div
                                fxLayout="row"
                                fxLayoutAlign="space-between center"
                            >
                                <h1
                                    class="text-14-semi-bold color-text-primary"
                                >
                                    Orçamento
                                </h1>
                            </div>

                            <div fxLayout="column" class="gap-8">
                                <div
                                    fxLayout="column"
                                    fxLayoutAlign="center center"
                                >
                                    <img
                                        class="report-toolbar-component_popover-image"
                                        [src]="
                                            company.analysisPlusStatus
                                                ? '/images/budget.png'
                                                : '/images/budget-y.png'
                                        "
                                        alt=""
                                    />
                                </div>

                                <p
                                    class="color-text-hint text-12-regular"
                                    fxLayout="column"
                                    fxLayoutAlign="center center"
                                >
                                    Ative o orçamento e identifique
                                    oportunidades de crescimento
                                </p>
                                @if (company?.analysisPlusStatus) {
                                    <div
                                        fxLayout="column"
                                        fxLayoutAlign="start center"
                                        class="gap-16"
                                    >
                                        <dsn-select
                                            class="full-width"
                                            [size]="'small'"
                                            [value]="formBudget._id"
                                            [placeholder]="
                                                'Selecione o orçamento'
                                            "
                                            (handleValueChange)="
                                                onSelectBudget($event)
                                            "
                                        >
                                            @for (
                                                budget of budgets;
                                                track $index
                                            ) {
                                                <dsn-option
                                                    [value]="budget.props._id"
                                                    >{{
                                                        budget.props.name
                                                    }}</dsn-option
                                                >
                                            }
                                        </dsn-select>
                                    </div>
                                }
                            </div>

                            @if (!loading && company?.analysisPlusStatus) {
                                <div
                                    fxLayout="row"
                                    fxLayoutAlign="end center"
                                    class="gap-16"
                                >
                                    <dsn-button
                                        [label]="'Limpar'"
                                        [type]="'secondary'"
                                        [size]="'medium'"
                                        [disabled]="loading || !options?.budget"
                                        [iconLeft]="'fa-solid fa-trash-can'"
                                        (onClick)="
                                            handleResetBudget.emit();
                                            popoverBudget.close()
                                        "
                                    ></dsn-button>
                                    <dsn-button
                                        [label]="'Aplicar'"
                                        [type]="'primary'"
                                        [size]="'medium'"
                                        [disabled]="loading || !formBudget._id"
                                        (onClick)="
                                            onApplyBudget();
                                            popoverBudget.close()
                                        "
                                    ></dsn-button>
                                </div>
                            } @else {
                                <dsn-button
                                    label="Solicitar Análise Plus"
                                    type="accent"
                                    [size]="'medium'"
                                    [width]="'full'"
                                    (onClick)="
                                        onRequestAnalysisPlus();
                                        popoverBudget.close()
                                    "
                                ></dsn-button>
                            }
                        </div>
                    </ng-template>
                </ngx-popover>
            }
            @if (dropdowns?.goals) {
                <ngx-popover
                    placement="bottom-start"
                    #popoverGoals
                    [disabled]="pdf"
                >
                    <div style="position: relative">
                        @if (!loading && !company?.analysisPlusStatus && !pdf) {
                            <app-badge-rocket></app-badge-rocket>
                        }
                        <div style="position: relative">
                            @if (pdf) {
                                <i
                                    class="fa-solid fas fa-lock"
                                    style="
                                        font-size: var(--font-size-12);
                                        color: var(--color-button-icon-hint);
                                        position: absolute;
                                        right: 4px;
                                        top: -6px;
                                        z-index: 10;
                                    "
                                ></i>
                            }
                            <dsn-button
                                [label]="'Objetivo'"
                                [type]="'tertiary'"
                                [fontWeight]="'regular'"
                                [size]="this.pdf ? 'x-small' : 'medium'"
                                [disabled]="loading"
                                [iconLeft]="'fa-solid fa-bullseye'"
                                [iconRight]="
                                    !this.pdf && 'fa-solid fa-caret-down'
                                "
                                [active]="options?.goals"
                                [shadow]="!pdf"
                            ></dsn-button>
                        </div>
                    </div>
                    <ng-template ngx-popover-template>
                        <div
                            class="dsn-popover size-minimum gap-16 report-toolbar-component_popover"
                            fxLayout="column"
                        >
                            <div
                                fxLayout="row"
                                fxLayoutAlign="space-between center"
                            >
                                <h1
                                    class="text-14-semi-bold color-text-primary"
                                >
                                    Objetivo
                                </h1>
                            </div>

                            <div fxLayout="column" class="gap-8">
                                <div
                                    fxLayout="column"
                                    fxLayoutAlign="center center"
                                >
                                    <img
                                        class="report-toolbar-component_popover-image"
                                        [src]="
                                            company.analysisPlusStatus
                                                ? '/images/objective.png'
                                                : '/images/objective-y.png'
                                        "
                                        alt=""
                                    />
                                </div>

                                <p
                                    class="color-text-hint text-12-regular"
                                    fxLayout="column"
                                    fxLayoutAlign="center center"
                                >
                                    Defina e acompanhe objetivos para cada
                                    indicador.
                                </p>
                            </div>
                            @if (!loading && company?.analysisPlusStatus) {
                                <div
                                    fxLayout="row"
                                    fxLayoutAlign="end center"
                                    class="gap-16"
                                >
                                    <dsn-button
                                        [label]="'Limpar'"
                                        [type]="'secondary'"
                                        [size]="'medium'"
                                        [disabled]="!options?.goals || loading"
                                        [iconLeft]="'fa-solid fa-trash-can'"
                                        [fontWeight]="'bold'"
                                        (click)="
                                            handleResetGoals.emit();
                                            popoverGoals.close()
                                        "
                                    ></dsn-button>
                                    <dsn-button
                                        [label]="'Aplicar'"
                                        [type]="'primary'"
                                        [size]="'medium'"
                                        [disabled]="loading"
                                        [fontWeight]="'bold'"
                                        (click)="
                                            handleChangeGoals.emit();
                                            popoverGoals.close()
                                        "
                                    ></dsn-button>
                                </div>
                            } @else {
                                <dsn-button
                                    label="Solicitar Análise Plus"
                                    type="accent"
                                    [size]="'medium'"
                                    [width]="'full'"
                                    (onClick)="
                                        onRequestAnalysisPlus();
                                        popoverGoals.close()
                                    "
                                ></dsn-button>
                            }
                        </div>
                    </ng-template>
                </ngx-popover>
            }
        </div>
        <div class="report-toolbar-component_mobile">
            @defer (when !loading) {
                @if (adjustments) {
                    <dsn-button-squared
                        [label]="'Ajustes'"
                        [type]="'secondary'"
                        [icon]="'fa-solid fa-sliders'"
                        [disabled]="loading"
                        (click)="onAdjustmentsClick()"
                    ></dsn-button-squared>
                }
            } @placeholder {
                <dsn-skeleton-loader
                    [type]="'rectangle'"
                    [width]="'88px'"
                    [height]="'52px'"
                ></dsn-skeleton-loader>
            }
        </div>
    </div>
    @if (pdf) {
        <div
            fxLayout="row"
            fxLayoutAlign="end center"
            style="padding: var(--spacing-12) var(--spacing-16) 0 0"
        >
            <dsn-button-link
                [label]="'Recurso exclusivo do digital'"
                [href]="linkDigital"
                [icons]="['fa-solid fa-lock', 'fa-solid fa-external-link']"
            ></dsn-button-link>
        </div>
    }
</div>
